import React from "react";
import { NavLink } from "react-router-dom";
import {
  FaUsers,
  FaPaperPlane,
  FaFlag,
  FaSignOutAlt,
  FaHome,
} from "react-icons/fa";
import { MdPayments } from "react-icons/md";
import { AiOutlineBarChart } from "react-icons/ai";
import { useNavigate } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "../sidenavbar.css";
import logo from "../assetss/kvl17.png";

export default function Sidebar({ open, collapsed, toggleSidebar }) {
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.clear();
    navigate("/", { replace: true });
  };
  const navItems = [
    { to: "/", icon: <FaHome />, label: "Home", exact: true },
    { to: "/admin/candidates", icon: <FaUsers />, label: "Candidate" },
    { to: "/admin/attempteduser", icon: <FaUsers />, label: "Attempted Users" },
    { to: "/admin/plan", icon: <FaPaperPlane />, label: "Plan" },
    {
      to: "/admin/activityreport",
      icon: <AiOutlineBarChart />,
      label: "Activity",
    },
    // { to: "/admin/complainreport", icon: <SiTraefikproxy />, label: "Report" },
    { to: "/admin/subscription", icon: <FaFlag />, label: "Subscr." },
    { to: "/admin/payments", icon: <MdPayments />, label: "Payments" },
  ];

  return (
    <div
      className={`sidebar ${open ? "active" : ""} ${collapsed ? "collapsed" : ""}`}
    >
      {/* Logo */}
      <div className="sidebar-logo">
        <img src={logo} alt="logo" className="sidebar-logo-img" />
      </div>

      {/* Nav */}
      <div className="menu-scroll">
        <ul className="nav flex-column text-center sidebar-nav">
          {navItems.map(({ to, icon, label, exact }) => (
            <li key={to}>
              <NavLink
                to={to}
                end={exact}
                className={({ isActive }) =>
                  `nav-link flex-column${isActive ? " active" : ""}`
                }
                onClick={toggleSidebar}
              >
                <span className="nav-icon">{icon}</span>
                <span className="text-sm">{label}</span>
              </NavLink>
            </li>
          ))}

          <li className="nav-divider-wrap">
            <div className="nav-divider" />
          </li>


          <li>
            <div
              onClick={handleLogout}
              className="nav-link flex-column logout-link"
            >
              <span className="nav-icon">
                <FaSignOutAlt />
              </span>
              <span className="text-sm">Logout</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}
